var blogSwiperSlide = new Swiper(".blog-swiper-slide", {
  direction: "horizontal",
  slidesPerView: "auto",
  centeredSlides: false,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: "bullets",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
